/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log( 'Hello World! (from create-block-accordion-item block)' );
/* eslint-enable no-console */

import { InnerBlocks } from '@wordpress/block-editor';

export default function save({ attributes }) {
    const { title } = attributes;

    return (
        <div className='c-accordion__section' data-accordion='wrap'>
            <div className='c-accordion__header' data-accordion='trigger'>
                <h3 className='c-accordion__header__title'>
                    <button className='c-accordion__button' aria-expanded='false' type='button' aria-label='Ouvrir {title}'>
                        {title}
                    </button>
                </h3>
            </div>
            <div className='c-accordion__content' role='region' data-accordion='content'>
                <div className='c-accordion__inner'>
                    <InnerBlocks.Content />
                </div>
            </div>
        </div>
    );
}
